import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { FaEllipsisV } from 'react-icons/fa';
import useFloatingMenu from '../../../../../ReusableBlocks/useFloatingMenu';

const TenantActionMenu = ({ tenant, actions, onAction }) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = useCallback(() => setIsOpen(false), []);
  const { triggerRef, menuRef, position } = useFloatingMenu({
    isOpen,
    onClose: closeMenu,
    align: 'right',
    gap: 4,
  });

  const handleAction = (action) => {
    setIsOpen(false);
    onAction(action.key, tenant);
  };

  return (
    <div className="stm-action-menu" ref={triggerRef}>
      <button
        type="button"
        className="stm-icon-btn stm-action-menu__trigger"
        aria-label={`Actions for Tenant ${tenant.tenantNumber}`}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        onClick={(event) => {
          event.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
      >
        <FaEllipsisV />
      </button>
      {isOpen && createPortal(
        <div
          ref={menuRef}
          className="stm-action-menu__list stm-action-menu__list--portal"
          role="menu"
          style={{ top: `${position.top}px`, left: `${position.left}px` }}
        >
          {actions.map((action) => (
            <button
              key={action.key}
              type="button"
              role="menuitem"
              className={`stm-action-menu__item ${action.destructive ? 'is-destructive' : ''}`}
              onClick={(event) => {
                event.stopPropagation();
                handleAction(action);
              }}
            >
              {action.label}
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
};

export default TenantActionMenu;
